import { createElement } from 'react'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { Delete } from '../shared/local/components/deleteButton'
import { Update } from '../shared/local/components/updateButton'

// Create common beneficiary control
export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
  },
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Surname',
    accessor: 'surname',
  },
  {
    Header: 'Nationality',
    accessor: 'nationality',
    minWidth: 130,
    width: 130,
  },
  {
    Header: 'Sport',
    accessor: 'sport',
  },
  {
    Header: 'Date Of Birth',
    accessor: 'dateOfBirth',
  },
  {
    Header: 'Update',
    id: 'controls',
    minWidth: 110,
    width: 110,
    accessor: (value) => value,
    Cell: (props) => createElement(Update, { ...props }),
  },
  {
    Header: 'Delete',
    id: 'controls',
    minWidth: 130,
    width: 130,
    accessor: (value) => value,
    Cell: (props) => createElement(Delete, { ...props }),
  },
]
